import React from "react";
import { Breadcrumb, Typography } from "antd";
import { HomeOutlined, CaretRightOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";

/**
 *
 * @param items {Array[Object[{label, path, icon}]]} - An array of objects containing the 'label', 'path', and
 *                                                    optionally 'icon'
 * @param extraRight {React.ReactNode} - An optional React node to be rendered on the right side of the breadcrumb
 * @returns {JSX.Element}
 * @constructor
 */
const NavTrail = ({ items, extraRight, borderBottom = '' }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 24px', borderBottom }}>
      <Breadcrumb separator={<CaretRightOutlined style={{ color: "#000" }} />} >
        {/* Always display the Home icon and route to "/" */}
        <Breadcrumb.Item key="home" icon={<HomeOutlined />}>
          <Link to="/">Home</Link>
        </Breadcrumb.Item>

        {/* Map through the rest of the items */}
        {items.map((item, index) => {
          const isLastItem = index === items.length - 1;
          return (
            <Breadcrumb.Item key={index} icon={item.icon} onClick={item?.onClick}>
              {isLastItem && !item.path ? (
                <span>{item.label}</span>
              ) : (
                <Link to={item.path}>{item.label}</Link>
              )}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
      {extraRight}
    </div>
  );
};

export default NavTrail;